<template>
  <span v-if="ellipsis" ref="span1" class="line-label overflow-ellipsis" :title="label">{{ label }}</span>
  <span v-else ref="span2" class="line-label">{{ label }}</span>
</template>

<script>
export default {
  name: 'LineLabel',
  props: {
    label: { type: String, default: '' }
  },
  data() {
    return {
      ellipsis: false
    }
  },
  watch: {
    label() {
      this.ellipsis = false
      setTimeout(() => {
        this.handleTextOverflow()
      })
    }
  },
  mounted() {
    this.handleTextOverflow()
  },
  methods: {
    handleTextOverflow() {
      const span2 = this.$refs.span2
      if (span2) {
        const parent = span2.parentNode
        const parentStyle = window.getComputedStyle(parent)
        const paddingLeft = Number(parentStyle.paddingLeft.replace('px', ''))
        const paddingRight = Number(parentStyle.paddingRight.replace('px', ''))
        if (span2.offsetWidth > parent.offsetWidth - paddingLeft - paddingRight) {
          this.ellipsis = true
        }
      }
    }
  }
}
</script>

<style scoped>
.line-label {
  white-space: nowrap;
  line-height: normal;
  vertical-align: middle;
}

.overflow-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
